module.exports = __webpack_public_path__ + "media/images/flags/32/Basque-Country-613741150f98b66816d8bae8d5a49cad.png";